const GENERAL_PERMISSIONS = {
  SHARE_OBJECTS: 'SHARE_OBJECTS',
  USE_INTERACTIVE_DESIGN: 'USE_INTERACTIVE_DESIGN',
  DATASET_CLONE: 'DATASET_CLONE',
  PREDICTOR_CLONE: 'PREDICTOR_CLONE',
  PROJECT_CLONE: 'PROJECT_CLONE',
  MPO_CLONE: 'MPO_CLONE',
  CLUSTER_CREATE: 'CLUSTER_CREATE',
}
const PROJECT_PERMISSIONS = {
  PROJECT_CREATE: 'PROJECT_CREATE',
  PROJECT_EXECUTE: 'PROJECT_EXECUTE',
  PROJECT_UPDATE: 'PROJECT_UPDATE',
  PROJECT_DELETE: 'PROJECT_DELETE',
  PROJECT_CANCEL: 'PROJECT_CANCEL',
}
const DATASET_PERMISSIONS = {
  DATASET_CREATE_DEL: 'DATASET_CREATE_DEL',
  DATASET_CREATE_REACTIVITY: 'DATASET_CREATE_REACTIVITY',
  DATASET_MAKE_PUBLIC: 'DATASET_MAKE_PUBLIC',
  DATASET_CREATE_FROM_S3_PATH: 'DATASET_CREATE_FROM_S3_PATH',
  DATASET_CREATE: 'DATASET_CREATE',
  DATASET_UPDATE: 'DATASET_UPDATE',
  DATASET_DELETE: 'DATASET_DELETE',
  DATASET_CANCEL: 'DATASET_CANCEL',
  DATASET_SELECT_TRAINING_SCHEME: 'DATASET_SELECT_TRAINING_SCHEME',
  DATASET_CRITERIA_BUILDER: 'DATASET_CRITERIA_BUILDER',
  DATASET_DEL_RULES_OVERRIDE: 'DATASET_DEL_RULES_OVERRIDE',
  DATASET_DEL_THRESHOLD_BUILDER: 'DATASET_DEL_THRESHOLD_BUILDER'
}
const PREDICTOR_PERMISSIONS = {
  PREDICTOR_TRAIN: 'PREDICTOR_TRAIN',
  PREDICTOR_CREATE: 'PREDICTOR_CREATE',
  PREDICTOR_UPDATE: 'PREDICTOR_UPDATE',
  PREDICTOR_MAKE_PUBLIC: 'PREDICTOR_MAKE_PUBLIC',
  PREDICTOR_CANCEL_TRAINING: 'PREDICTOR_CANCEL_TRAINING',
  PREDICTOR_DELETE: 'PREDICTOR_DELETE',
  PREDICTOR_SELECT_TRAINING_SCHEME: 'PREDICTOR_SELECT_TRAINING_SCHEME'
}
const MPO_PERMISSIONS = {
  MPO_CREATE: 'MPO_CREATE',
  MPO_EXECUTE: 'MPO_EXECUTE',
  MPO_UPDATE: 'MPO_UPDATE',
  MPO_DELETE: 'MPO_DELETE',
  MPO_CANCEL: 'MPO_CANCEL',
}
const FOLDER_PERMISSIONS = {
  FOLDER_CREATE: 'FOLDER_CREATE',
  FOLDER_DELETE: 'FOLDER_DELETE',
  FOLDER_UPDATE: 'FOLDER_UPDATE',
}

const FILE_STORAGE_PREMISSIONS = {
  FILE_STORAGE_VIEW: 'FILE_STORAGE_VIEW',
  FILE_STORAGE_UPDATE: 'FILE_STORAGE_UPDATE',
  FILE_STORAGE_CREATE: 'FILE_STORAGE_CREATE',
  FILE_STORAGE_DELETE: 'FILE_STORAGE_DELETE',
  FILE_STORAGE_DOWNLOAD: 'FILE_STORAGE_DOWNLOAD',
  FILE_STORAGE_UPLOAD: 'FILE_STORAGE_UPLOAD',
  FILE_STORAGE_MAKE_PUBLIC: 'FILE_STORAGE_MAKE_PUBLIC'
}

const DEL_DELIVERY_PERMISSIONS = {
  DEL_DELIVERY_CREATE: 'DEL_DELIVERY_CREATE',
  DEL_DELIVERY_VIEW: 'DEL_DELIVERY_VIEW'
}

const WORKFLOW_PERMISSIONS = {
  WORKFLOW_CREATE: 'WORKFLOW_CREATE',
  WORKFLOW_UPDATE: 'WORKFLOW_UPDATE',
  WORKFLOW_RUN: 'WORKFLOW_RUN',
  WORKFLOW_VIEW: 'WORKFLOW_VIEW',
  WORKFLOW_DELETE: 'WORKFLOW_DELETE',
  WORKFLOW_CANCEL: 'WORKFLOW_CANCEL',
}

export const PERMISSIONS = {
  ...GENERAL_PERMISSIONS,
  ...PROJECT_PERMISSIONS,
  ...DATASET_PERMISSIONS,
  ...PREDICTOR_PERMISSIONS,
  ...MPO_PERMISSIONS,
  ...FOLDER_PERMISSIONS,
  ...WORKFLOW_PERMISSIONS,
  ...FILE_STORAGE_PREMISSIONS,
  ...DEL_DELIVERY_PERMISSIONS,
}
